// removed by extract-text-webpack-plugin
module.exports = {"hero-content":"_2XJgF","heroContent":"_2XJgF","hero":"_1uRdy","link-more":"j8P3x","linkMore":"j8P3x","hero-wrap":"_1-kk0","heroWrap":"_1-kk0"};